import { render, staticRenderFns } from "./guanli.vue?vue&type=template&id=4c34ae94&scoped=true&"
import script from "./guanli.vue?vue&type=script&lang=js&"
export * from "./guanli.vue?vue&type=script&lang=js&"
import style0 from "./guanli.vue?vue&type=style&index=0&id=4c34ae94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c34ae94",
  null
  
)

export default component.exports